import { xzLocal, xzSession } from '../../until/common';
import {
PAYTYPE,
WITHDRAWTYPE,
FITLABELLIST,
} from '../mutation-type';

const state = {
    payType: {},
    withdrawType: {},
    fitlabelList: [],
  ...(localStorage.getItem('ehammer.state') ? ({
    payType: {},
    withdrawType: {},
    fitlabelList: [],
}, JSON.parse(localStorage.getItem('ehammer.state')).pay) : {
    payType: {},
    withdrawType: {},
    fitlabelList: [],
  }),
  };

const mutations = {
  [PAYTYPE]: (s, payType) => {
    Object.assign(s.payType, payType);
  },
  [WITHDRAWTYPE]: (s, withdrawType) => {
    Object.assign(s.withdrawType, withdrawType);
  },
  [FITLABELLIST]: (s, list) => {
    s.fitlabelList = list;
  },
};

export default {
  state,
  mutations,
};
